import * as React from "react";
import ArrayUtils from "./util/array";
import { useEngine } from "./useEngine";
import { SettingRow, SettingSelect } from "./SettingsWidgets";
var KittySizeSelector = function (props) {
    var engine = useEngine();
    var _a = React.useState(0), deckLen = _a[0], setDeckLen = _a[1];
    var _b = React.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    React.useEffect(function () {
        setIsLoading(true);
        engine
            .computeDeckLen(props.decks)
            .then(function (len) {
            setDeckLen(len);
            setIsLoading(false);
        })
            .catch(function (error) {
            console.error("Error computing deck length:", error);
            // Fallback: estimate based on number of decks
            setDeckLen(props.decks.length * 54);
            setIsLoading(false);
        });
    }, [props.decks, engine]);
    var handleChange = function (e) {
        var newKittySize = e.target.value === "" ? null : parseInt(e.target.value, 10);
        props.onChange(newKittySize);
    };
    var kittyOffset = deckLen % props.numPlayers;
    var defaultOptions = [
        kittyOffset,
        kittyOffset + props.numPlayers,
        kittyOffset + 2 * props.numPlayers,
        kittyOffset + 3 * props.numPlayers,
        kittyOffset + 4 * props.numPlayers,
    ];
    var potentialOptions = ArrayUtils.range(kittyOffset + 4 * props.numPlayers, function (v) { return v; });
    var options = potentialOptions.filter(function (v) {
        return !defaultOptions.includes(v) &&
            v < deckLen - props.numPlayers &&
            // Note: this isn't quite right, but it seems fine for the common case of no short decks.
            (deckLen - v) % props.numPlayers <= props.decks.length * 4;
    });
    if (isLoading) {
        return (React.createElement(SettingRow, { label: "Number of cards in the bottom" },
            React.createElement("span", { className: "text-sm text-[var(--text-secondary)]" }, "Loading options\u2026")));
    }
    return (React.createElement(SettingRow, { label: "Number of cards in the bottom", htmlFor: "kitty-size-selector" },
        React.createElement(SettingSelect, { id: "kitty-size-selector", value: props.kittySize !== undefined && props.kittySize !== null
                ? props.kittySize
                : "", onChange: handleChange },
            React.createElement("optgroup", { label: "Standard" },
                React.createElement("option", { value: "" }, "default"),
                defaultOptions
                    .filter(function (v) { return v < deckLen - props.numPlayers; })
                    .map(function (v) { return (React.createElement("option", { value: v, key: v },
                    v,
                    " card",
                    v === 1 ? "" : "s")); })),
            React.createElement("optgroup", { label: "Requires removing cards from the deck" }, options.map(function (v) { return (React.createElement("option", { value: v, key: v },
                v,
                " card",
                v === 1 ? "" : "s")); })))));
};
export default KittySizeSelector;
